import React from 'react'
import { SvgIconProps } from './Home'

const SvgWaiverIcon = ({ fill, width, height }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width ?? "16"}
    height={height ?? "19"}
    fill="none"
    viewBox="0 0 16 19"
  >
    <path
      fill={fill ?? "#353535"}
      d="M3.784 11.398a.958.958 0 00-.973.95c0 .528.432.95.973.95.54 0 .973-.422.973-.95a.958.958 0 00-.973-.95zM3.784 8.867a.958.958 0 00-.973.95c0 .528.432.95.973.95.54 0 .973-.422.973-.95a.958.958 0 00-.973-.95zM3.784 13.934a.958.958 0 00-.973.95c0 .527.432.95.973.95.54 0 .973-.423.973-.95a.958.958 0 00-.973-.95zM12.216 13.934H5.73a.958.958 0 00-.973.95c0 .527.432.95.973.95h6.486c.54 0 .973-.423.973-.95a.958.958 0 00-.973-.95zM4.865 9.817c0 .528.432.95.973.95h6.486c.54 0 .973-.422.973-.95a.958.958 0 00-.973-.95H5.838a.958.958 0 00-.973.95z"
    ></path>
    <path
      fill={fill ?? "#353535"}
      d="M15.784 5.067L10.919.317C10.703.106 10.486 0 10.162 0H3.027C1.405 0 0 1.372 0 2.956v13.088C0 17.734 1.405 19 3.027 19h9.946C14.595 19 16 17.628 16 16.044V5.7c0-.211 0-.528-.216-.633zm-3.46-.317c-.648 0-1.189-.528-1.189-1.161v-.422l1.622 1.583h-.433zm0 1.9h1.838v9.394c0 .634-.54 1.162-1.189 1.162H3.027c-.649 0-1.19-.528-1.19-1.162V2.956c0-.634.541-1.162 1.19-1.162h6.27V3.59c0 1.689 1.298 3.061 3.027 3.061z"
    ></path>
    <path
      fill={fill ?? "#353535"}
      d="M12.216 11.398H5.73a.958.958 0 00-.973.95c0 .528.432.95.973.95h6.486c.54 0 .973-.422.973-.95a.958.958 0 00-.973-.95zM6.378 6.863v-.634h.649c.54 0 .973-.422.973-.95a.958.958 0 00-.973-.95h-.649v-.633a.958.958 0 00-.973-.95c-.54 0-.864.422-.864.95v.633h-.757a.958.958 0 00-.973.95c0 .528.432.95.973.95h.648v.634c.109.528.433.95.973.95s.973-.422.973-.95z"
    ></path>
  </svg>
)

export default SvgWaiverIcon